export default function AppErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="max-w-md text-center">
        <h1 className="mb-3 text-3xl font-semibold tracking-tight">Something went wrong</h1>
        <p className="mb-6 text-muted-foreground">
          An unexpected error occurred. Our team has been notified. Please reload the page to continue.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="inline-flex items-center rounded-md bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Reload page
        </button>
      </div>
    </div>
  );
}